module.exports = __webpack_public_path__ + "img/sm-map-4ad7c7.png";